
export default {
  name: 'MegasredaRecomendedAuthorBlocksEventsBlock',
  props: {
    events: {
      type: Object,
      default: null,
    },
    authorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isDeferred: true,
      isShowMenu: false,
    }
  },
  computed: {
    isAuthor() {
      if (this.$auth.loggedIn && this.authorId) {
        return this.$auth?.user?._id === this.authorId
      } else {
        return false
      }
    },
    cookieName() {
      return `${this.authorId}deferedEventsMessage`
    },
  },
  mounted() {
    this.isDeferred = this.$cookies.get(this.cookieName)
  },
  methods: {
    setDeferred(period) {
      const maxAge = period === 'month' ? 60 * 60 * 24 * 30 : 60 * 60 * 24 * 7
      this.$cookies.set(this.cookieName, true, {
        path: '/',
        maxAge,
      })
      this.isDeferred = this.$cookies.get(this.cookieName)
      this.isShowMenu = false
    },

    closeMenu() {
      this.isShowMenu = false
    },
  },
}
